import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo, ThemeToggle, Spinner } from "@/components/app/common";
import { PackageCard, CheckoutDialog } from "@/components/app/Checkout";
import { useAuth } from "@/context/AuthContext";
import { api, tl, dt } from "@/lib/api";
import { StatusBadge } from "@/lib/labels";

export default function Activation() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [reg, setReg] = useState(null);
  const [orders, setOrders] = useState([]);
  const [buy, setBuy] = useState(null);
  useEffect(() => {
    if (user?.status === "ACTIVE") { nav("/panel", { replace: true }); return; }
    api.get("/products").then(({ data }) => setReg(data.find((p) => p.kind === "REGISTRATION") || false));
    api.get("/orders").then(({ data }) => setOrders(data.items));
  }, [user, nav]);
  return (
    <div className="min-h-screen">
      <header className="glass sticky top-0 z-30 flex h-16 items-center justify-between border-x-0 border-t-0 px-4 sm:px-8">
        <Logo /><div className="flex gap-2"><ThemeToggle /><Button variant="ghost" size="sm" onClick={async () => { await logout(); nav("/giris"); }} data-testid="activation-logout"><LogOut className="mr-2 h-4 w-4" />Çıkış</Button></div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-8 animate-fade-up" data-testid="activation-page">
        <div className="eyebrow">Son adım</div>
        <h1 className="mt-3 text-3xl font-bold sm:text-4xl">Merhaba {user?.first_name}, hesabınızı aktif edin.</h1>
        <p className="mt-3 text-muted-foreground">Ödeme tamamlandığında hesabınız aktif edilir ve kredileriniz otomatik olarak tanımlanır.</p>
        <div className="mt-10 max-w-md">
          {reg === null ? <Spinner /> : reg ? <PackageCard p={reg} onBuy={setBuy} cta="Paketi Satın Al" /> : <p>Kayıt paketi şu anda satışta değil. Lütfen destek ile iletişime geçin.</p>}
        </div>
        {orders.length > 0 && (
          <div className="mt-12">
            <h2 className="flex items-center gap-2 text-lg font-semibold"><Clock className="h-4 w-4" />Siparişlerim</h2>
            <div className="mt-4 space-y-2">
              {orders.map((o) => (
                <Link key={o.id} to={`/siparis/${o.id}`} data-testid={`activation-order-${o.order_no}`} className="glass-card glass-card-hover flex items-center justify-between p-4 text-sm">
                  <span><b>{o.order_no}</b> <span className="text-muted-foreground">· {dt(o.created_at)}</span></span>
                  <span className="flex items-center gap-3">{tl(o.final_amount)}<StatusBadge status={o.status} /></span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </main>
      <CheckoutDialog product={buy} onClose={() => setBuy(null)} />
    </div>
  );
}
